/*
* Report page
*/

import * as _ from 'lodash';
import * as React from 'react';

import * as PropertyReportComponents from '../report-components';
// import GoogleMapLink from '../../../common/googlemaplink';
import { Row } from 'react-bootstrap';
import { BootstrapColXl as Col } from 'src/common/bootstrap/bootstrapcolxl';
import { Formatters } from '../../../common/formatters';
import GoogleMapEmbed from '../../../common/googlemapembed';

export const Render = ({ reportData, ...rest }) => {
    const { association, associationId, ...otherReportData } = reportData;
    const assocLocation = _.get(association, 'location', {});

    return (
        <div>
            <PropertyReportComponents.PropertyReportPage className="pdf-association-property-report-map-page" reportData={reportData}>
                <Col xs={12} className="pdf-association-property-report-map-title">
                    <Row>
                        <div className="text-center pdf-association-property-report-map-wrapper">
                            <GoogleMapEmbed
                                locationDocument={assocLocation}
                                enabled={true}
                                mapWidth={740}
                                mapHeight={640}
                                mapZoom={15}
                            />
                            { /* <GoogleMapLink
                        locationDocument={assocLocation}
                        enabled={true}
                        mapWidth={640}
                        mapHeight={640}
                        mapZoom={15}
                        mapScale={2}
                        renderHyperlink={true}
                    /> */ }
                        </div>
                    </Row>
                    <Row>
                        <div className="pdf-association-property-report-map-address">
                            {Formatters.getStr(association, 'name')}<br />
                            {Formatters.getStr(assocLocation, 'address1')}<br />
                            {Formatters.composeLocationCityStateZipCountry(assocLocation, false)}<br />
                        </div>
                    </Row>
                </Col>
            </PropertyReportComponents.PropertyReportPage>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/association/property-report/pages/report-page-map.tsx